if (!customElements.get('cookie-consent')) {
  class CookieConsent extends HTMLElement {
    constructor() {
      super();

      this._banner = this.querySelector('[data-banner]');
      this._modal = this.querySelector('[data-prefs-modal]');
      this._card = this._modal.querySelector('[data-prefs-card]');
      this._backdrop = this._modal.querySelector('[data-prefs-backdrop]');

      this._hasApi = false;
      this._modalOpen = false;
      this._delay = parseInt(this.getAttribute('data-delay') || '3000', 10);
      this._expiration = parseInt(this.getAttribute('data-expiration') || '365', 10);

      this.consent = { analytics: false, marketing: false, preferences: false };

      this._loadApi();
      this._bindEvents();
      this._checkAndShow();
    }

    _loadApi() {
      var self = this;
      try {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            self._hasApi = !error;
          }
        );
      } catch (e) {
        self._hasApi = false;
      }
    }

    _bindEvents() {
      var self = this;

      this.querySelectorAll('[data-accept]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._acceptAll(); });
      });

      this.querySelectorAll('[data-decline]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._declineAll(); });
      });

      this.querySelectorAll('[data-manage]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._openPreferences(); });
      });

      this.querySelectorAll('[data-accept-all]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._acceptAll(); });
      });

      this.querySelectorAll('[data-decline-all]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._declineAll(); });
      });

      this.querySelectorAll('[data-save]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._saveChoices(); });
      });

      this.querySelectorAll('[data-prefs-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._closePreferences(); });
      });

      this.querySelectorAll('[data-toggle]').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var category = toggle.getAttribute('data-toggle');
          var isOn = toggle.getAttribute('aria-checked') === 'true';
          toggle.setAttribute('aria-checked', String(!isOn));
          self.consent[category] = !isOn;
        });
      });

      this._backdrop.addEventListener('click', function (e) {
        if (e.target === self._backdrop) self._closePreferences();
      });

      document.addEventListener('keydown', function (e) {
        if (self._modalOpen && e.key === 'Escape') self._closePreferences();
      });
    }

    _checkAndShow() {
      if (typeof window.expireStorageItem === 'function') {
        var existing = window.expireStorageItem('milamend_cookie_consent');
        if (existing) return;
      }

      var self = this;
      setTimeout(function () { self._showBanner(); }, self._delay);
    }

    _showBanner() {
      this._banner.classList.remove('pointer-events-none');
      this._banner.animate(
        [
          { opacity: 0, transform: 'translateY(100%)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 350, easing: 'ease-out', fill: 'forwards' }
      );
    }

    _hideBanner(callback) {
      var anim = this._banner.animate(
        [
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(100%)' }
        ],
        { duration: 250, easing: 'ease-in', fill: 'forwards' }
      );
      var self = this;
      anim.onfinish = function () {
        self._banner.classList.add('pointer-events-none');
        if (callback) callback();
      };
    }

    _openPreferences() {
      var self = this;
      this._hideBanner(function () {
        self._modal.classList.remove('hidden');
        self._modalOpen = true;
        document.body.style.overflow = 'hidden';

        self._modal.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 250, easing: 'ease-out', fill: 'forwards' }
        );
        self._card.animate(
          [
            { opacity: 0, transform: 'scale(0.95) translateY(20px)' },
            { opacity: 1, transform: 'scale(1) translateY(0)' }
          ],
          { duration: 300, easing: 'ease-out', fill: 'forwards' }
        );
      });
    }

    _closePreferences() {
      var self = this;
      var backdropAnim = this._modal.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: 200, easing: 'ease-in', fill: 'forwards' }
      );
      this._card.animate(
        [
          { opacity: 1, transform: 'scale(1) translateY(0)' },
          { opacity: 0, transform: 'scale(0.95) translateY(20px)' }
        ],
        { duration: 200, easing: 'ease-in', fill: 'forwards' }
      );
      backdropAnim.onfinish = function () {
        self._modal.classList.add('hidden');
        self._modalOpen = false;
        document.body.style.overflow = '';
        self._showBanner();
      };
    }

    _acceptAll() {
      this.consent = { analytics: true, marketing: true, preferences: true };
      this._submitAndClose();
    }

    _declineAll() {
      this.consent = { analytics: false, marketing: false, preferences: false };
      this._submitAndClose();
    }

    _saveChoices() {
      this._submitAndClose();
    }

    _submitAndClose() {
      var self = this;

      if (this._hasApi && window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: self.consent.analytics,
            marketing: self.consent.marketing,
            preferences: self.consent.preferences
          },
          function () {}
        );
      }

      if (typeof window.setStorageItem === 'function') {
        window.setStorageItem(
          'milamend_cookie_consent',
          JSON.stringify(self.consent),
          self._expiration
        );
      }

      if (this._modalOpen) {
        var backdropAnim = this._modal.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 200, easing: 'ease-in', fill: 'forwards' }
        );
        this._card.animate(
          [
            { opacity: 1, transform: 'scale(1) translateY(0)' },
            { opacity: 0, transform: 'scale(0.95) translateY(20px)' }
          ],
          { duration: 200, easing: 'ease-in', fill: 'forwards' }
        );
        backdropAnim.onfinish = function () {
          self._modal.classList.add('hidden');
          self._modalOpen = false;
          document.body.style.overflow = '';
        };
      } else {
        this._hideBanner();
      }
    }
  }

  customElements.define('cookie-consent', CookieConsent);
}
